// @flow

export function getRelatedInputNameFromError(errorCode: string, country: string): string {
  const userField = getUserField(errorCode);

  if (typeof userField === 'string') {
    return userField;
  }

  if (typeof userField === 'object' && (country in userField)) {
    return userField[country];
  }

  throw new Error(`Can't get related input name for errorCode ${errorCode}`);
}

function getUserField(errorCode: string): string | { br: string } | void {
  switch (errorCode) {
    case 'BP-DR-13':
      return 'customerName';

    case 'BP-DR-15':
    case 'BP-DR-17':
    case 'BP-DR-98':
      return 'customerEmail';

    case 'BP-DR-22':
    case 'BP-DR-23':
      return {
        ar: 'argentineDocument',
        bo: 'bolivianDocument',
        br: 'brazilianDocument',
        cl: 'chileanDocument',
        co: 'colombianDocument',
        ec: 'ecuadorianDocument',
        mx: 'mexicanDocument',
        pe: 'peruvianDocument',
        uy: 'uruguayanDocument',
        cr: 'costaRicanDocument',
        py: 'paraguayanDocument',
        pa: 'panamanianDocument',
        sv: 'elSalvadorDocument',
        gt: 'guatemalanDocument',
        do: 'dominicanDocument',
        ke: 'kenyanDocument',
      };

    case 'BP-DR-24':
      return {
        ar: 'argentineZipcode',
        bo: 'bolivianZipcode',
        br: 'brazilianZipcode',
        cl: 'chileanZipcode',
        co: 'colombianZipcode',
        ec: 'ecuadorianZipcode',
        mx: 'mexicanZipcode',
        pe: 'peruvianZipcode',
        uy: 'uruguayanZipcode',
        cr: 'costaRicanZipcode',
        py: 'paraguayanZipcode',
        pa: 'panamanianZipcode',
        sv: 'elSalvadorZipcode',
        gt: 'guatemalanZipcode',
        do: 'dominicanZipcode',
        ke: 'kenyanZipcode',
        in: 'indiaZipcode',
      };

    case 'BP-DR-25':
      return {
        ar: 'argentineAddress',
        bo: 'bolivianAddress',
        br: 'brazilianAddress',
        cl: 'chileanAddress',
        co: 'colombianAddress',
        ec: 'ecuadorianAddress',
        mx: 'mexicanAddress',
        pe: 'peruvianAddress',
        uy: 'uruguayanAddress',
        cr: 'costaRicanAddress',
        py: 'paraguayanAddress',
        pa: 'panamanianAddress',
        sv: 'elSalvadorAddress',
        gt: 'guatemalanAddress',
        do: 'dominicanAddress',
        ke: 'kenyanAddress',
      };

    case 'BP-DR-26':
      return {
        ar: 'argentineStreetNumber',
        bo: 'bolivianStreetNumber',
        br: 'brazilianStreetNumber',
        cl: 'chileanStreetNumber',
        co: 'colombianStreetNumber',
        ec: 'ecuadorianStreetNumber',
        mx: 'mexicanStreetNumber',
        pe: 'peruvianStreetNumber',
        uy: 'uruguayanStreetNumber',
        cr: 'costaRicanStreetNumber',
        py: 'paraguayanStreetNumber',
        pa: 'panamanianStreetNumber',
        sv: 'elSalvadorStreetNumber',
        gt: 'guatemalanStreetNumber',
        do: 'dominicanStreetNumber',
        ke: 'kenyanStreetNumber',
      };

    case 'BP-DR-27':
      return {
        ar: 'argentineCity',
        bo: 'bolivianCity',
        br: 'brazilianCity',
        cl: 'chileanCity',
        co: 'colombianCity',
        ec: 'ecuadorianCity',
        mx: 'mexicanCity',
        pe: 'peruvianCity',
        uy: 'uruguayanCity',
        cr: 'costaRicanCity',
        py: 'paraguayanCity',
        pa: 'panamanianCity',
        sv: 'elSalvadorCity',
        gt: 'guatemalanCity',
        do: 'dominicanCity',
        ke: 'kenyanCity',
        in: 'indiaCity',
      };

    case 'BP-DR-28':
    case 'BP-DR-29':
      return {
        ar: 'argentineState',
        bo: 'bolivianState',
        br: 'brazilianState',
        cl: 'chileanState',
        co: 'colombianState',
        ec: 'ecuadorianState',
        mx: 'mexicanState',
        pe: 'peruvianState',
        uy: 'uruguayanState',
        cr: 'costaRicanState',
        py: 'paraguayanState',
        pa: 'panamanianState',
        sv: 'elSalvadorState',
        gt: 'guatemalanState',
        do: 'dominicanState',
        ke: 'kenyanState',
        in: 'indiaState',
      };

    case 'BP-DR-31':
    case 'BP-DR-32':
      return {
        ar: 'argentinePhoneNumber',
        bo: 'bolivianPhoneNumber',
        br: 'brazilianPhoneNumber',
        cl: 'chileanPhoneNumber',
        co: 'colombianPhoneNumber',
        ec: 'ecuadorianPhoneNumber',
        mx: 'mexicanPhoneNumber',
        pe: 'peruvianPhoneNumber',
        uy: 'uruguayanPhoneNumber',
        cr: 'costaRicanPhoneNumber',
        py: 'paraguayanPhoneNumber',
        pa: 'panamanianPhoneNumber',
        sv: 'elSalvadorPhoneNumber',
        gt: 'guatemalanPhoneNumber',
        do: 'dominicanPhoneNumber',
        ng: 'nigerianPhoneNumber',
        ke: 'kenyanPhoneNumber',
        in: 'indiaPhoneNumber',
        tz: 'tanzanianPhoneNumber',
        ug: 'ugandaPhoneNumber',
        zm: 'zambiaPhoneNumber',
        eg: 'egyptPhoneNumber',
        gh: 'ghanaPhoneNumber',
        tr: 'turkeyPhoneNumber',
        id: 'indonesianPhoneNumber',
      };

    case 'BP-DR-51':
    case 'BP-DR-95':
      return 'cardHolderName';

    case 'BP-DR-55':
      return 'cardSecurityCode';

    case 'BP-DR-67':
      return 'cardExpiryDate';

    case 'BP-DR-76':
      return 'selectedBankCode';

    case 'BP-DR-75':
    case 'BP-DR-83':
    case 'BP-DR-97':
    case 'BP-DR-100':
    case 'BP-DR-101':
      return 'cardNumber';

    case 'BP-DR-172':
      return 'nigerianAccountNumber';

    case 'BP-DR-174':
      return 'indiaUpiId';
  }
}

export function getUserErrorInputField(errorCode: string): ?string {
  switch (errorCode) {
    case 'BP-DR-13':
      return 'name';

    case 'BP-DR-22':
    case 'BP-DR-23':
      return 'document';

    case 'BP-DR-24':
      return 'zipcode';

    case 'BP-DR-25':
      return 'address';

    case 'BP-DR-26':
      return 'street_number';

    case 'BP-DR-27':
      return 'city';

    case 'BP-DR-28':
    case 'BP-DR-29':
      return 'state';

    case 'BP-DR-31':
    case 'BP-DR-32':
      return 'telephone';

    case 'default':
      return null;
  }
}
